/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ecommerce_Amazon_Tools_Sync_Title4Inputs */

const en_svc_ecommerce_amazon_tools_sync_title4 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Sync_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inventory sync`)
};

const ar_svc_ecommerce_amazon_tools_sync_title4 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Sync_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مزامنة المخزون`)
};

const bn_svc_ecommerce_amazon_tools_sync_title4 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Sync_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ইনভেন্টরি সিঙ্ক`)
};

const de_svc_ecommerce_amazon_tools_sync_title4 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Sync_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lagersynchronisation`)
};

const es_svc_ecommerce_amazon_tools_sync_title4 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Sync_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronización de inventario`)
};

const fr_svc_ecommerce_amazon_tools_sync_title4 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Sync_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synchronisation des stocks`)
};

const pt_svc_ecommerce_amazon_tools_sync_title4 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Sync_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronização de stock`)
};

const zh_svc_ecommerce_amazon_tools_sync_title4 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Sync_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`库存同步`)
};

const tr_svc_ecommerce_amazon_tools_sync_title4 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Sync_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stok senkronu`)
};

const ru_svc_ecommerce_amazon_tools_sync_title4 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Sync_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Синхронизация склада`)
};

const pl_svc_ecommerce_amazon_tools_sync_title4 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Sync_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synchronizacja magazynu`)
};

/**
* | output |
* | --- |
* | "Inventory sync" |
*
* @param {Svc_Ecommerce_Amazon_Tools_Sync_Title4Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ecommerce_amazon_tools_sync_title4 = /** @type {((inputs?: Svc_Ecommerce_Amazon_Tools_Sync_Title4Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ecommerce_Amazon_Tools_Sync_Title4Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ecommerce_amazon_tools_sync_title4(inputs)
	if (locale === "bn") return bn_svc_ecommerce_amazon_tools_sync_title4(inputs)
	if (locale === "de") return de_svc_ecommerce_amazon_tools_sync_title4(inputs)
	if (locale === "es") return es_svc_ecommerce_amazon_tools_sync_title4(inputs)
	if (locale === "fr") return fr_svc_ecommerce_amazon_tools_sync_title4(inputs)
	if (locale === "pt") return pt_svc_ecommerce_amazon_tools_sync_title4(inputs)
	if (locale === "zh") return zh_svc_ecommerce_amazon_tools_sync_title4(inputs)
	if (locale === "tr") return tr_svc_ecommerce_amazon_tools_sync_title4(inputs)
	if (locale === "ru") return ru_svc_ecommerce_amazon_tools_sync_title4(inputs)
	if (locale === "pl") return pl_svc_ecommerce_amazon_tools_sync_title4(inputs)
	return en_svc_ecommerce_amazon_tools_sync_title4(inputs)
});
export { svc_ecommerce_amazon_tools_sync_title4 as "svc_ecommerce-amazon-tools_SYNC_title" }